import {
  GridSlotProps,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton
} from "@mui/x-data-grid";
import React from "react";
import { CustomShimmer } from "../helper/CustomShimmer";
import { ExportCsvButton } from "../SharedComponents/ExportCsvButton";
import { ExportCsvButtonProps } from "../SharedComponents/Interfaces/ExportCsvButton.interfaces";
import DisplayAPIsException from "./DisplayAPIsExceptionAlert";

interface ISlot {
  noRowsOverlay: (error: boolean) => React.JSXElementConstructor<any>;
  noFavoriteCustomersOverlay: (error: boolean) => React.JSXElementConstructor<any>;
  noFavoriteProductsOverlay: (error: boolean) => React.JSXElementConstructor<any>;
  noFavoriteReportsOverlay: (error: boolean) => React.JSXElementConstructor<any>;
  noFavoritePartnersOverlay: (error: boolean) => React.JSXElementConstructor<any>;
  loadingOverlay: React.JSXElementConstructor<any>;
  toolbar: (exportButtonProps: ExportCsvButtonProps) => React.JSXElementConstructor<GridSlotProps["toolbar"]> | null;
}
const DATAGRID_SLOTS = {
  noRowsOverlay: (error: boolean = false) => (error ? DisplayAPIsException : CustomNoRowsOverlay),
  noFavoriteCustomersOverlay: (error: boolean = false) => (error ? DisplayAPIsException : NoFavoriteCustomersOverlay),
  noFavoriteProductsOverlay: (error: boolean = false) => (error ? DisplayAPIsException : NoFavoriteProductsOverlay),
  noFavoriteReportsOverlay: (error: boolean = false) => (error ? DisplayAPIsException : NoFavoriteReportsOverlay),
  noFavoritePartnersOverlay: (error: boolean = false) => (error ? DisplayAPIsException : NoFavoritePartnersOverlay),
};

const styles = {
  container: {
    height: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } as React.CSSProperties,
  item: {} as React.CSSProperties
};

const CustomToolbar = ({
  fileNamePrefix = "security360-export",
  tooltip = "Export CSV",
  buttonLabel = "Export"
}: ExportCsvButtonProps) => {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <ExportCsvButton buttonLabel={buttonLabel} fileNamePrefix={fileNamePrefix} tooltip={tooltip} />
    </GridToolbarContainer>
  );
};

const CustomNoRowsOverlay = () => (
  <div style={styles.container}>
    <div>No Rows Found</div>
  </div>
);

const NoFavoriteCustomersOverlay = () => (
  <div style={styles.container}>
    <div>You have not favorited any customer yet. Try clicking the &#128153; icon in Customer Page to favorite a customer.</div>
  </div>
);

const NoFavoriteProductsOverlay = () => (
  <div style={styles.container}>
    <div>You have not favorited any product yet. Try clicking the &#128153; icon in Product View Page to favorite a product.</div>
  </div>
);

const NoFavoriteReportsOverlay = () => (
  <div style={styles.container}>
    <div>You have not favorited any report yet. Try clicking the &#128153; icon in Report Page to favorite a report.</div>
  </div>
);

const NoFavoritePartnersOverlay = () => (
  <div style={styles.container}>
    <div>You have not favorited any partner yet. Try clicking the &#128153; icon in Partner Page to favorite a partner.</div>
  </div>
);

export const DATA_GRID_SLOTS: ISlot = {
  noRowsOverlay: (error: boolean = false) => DATAGRID_SLOTS.noRowsOverlay(error),
  loadingOverlay: CustomShimmer,
  toolbar: (exportButtonProps: ExportCsvButtonProps) => (props) => <CustomToolbar {...exportButtonProps} {...props} />,
  noFavoriteCustomersOverlay: (error: boolean = false) => DATAGRID_SLOTS.noFavoriteCustomersOverlay(error),
  noFavoriteProductsOverlay: (error: boolean = false) => DATAGRID_SLOTS.noFavoriteProductsOverlay(error),
  noFavoriteReportsOverlay: (error: boolean = false) => DATAGRID_SLOTS.noFavoriteReportsOverlay(error),
  noFavoritePartnersOverlay: (error: boolean = false) => DATAGRID_SLOTS.noFavoritePartnersOverlay(error)
};
